import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useMemo, useContext } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { DataReportsProvider, DataTransferTemplateProvider, StudiesProvider } from 'libs.data';
import { FeatureFlagsContext } from 'libs.flags.react';
import { SideNav, Spinner } from 'libs.nucleus';
import { useUserRoles } from 'libs.react_internal';
const ProvidersWrapper = ({ children }) => {
    return (_jsx(StudiesProvider, { children: _jsx(DataTransferTemplateProvider, { children: _jsx(DataReportsProvider, { children: children }) }) }));
};
export const LibraryWrapper = () => {
    const { pathname } = useLocation();
    const { isAdmin, isBuilder, isLibrarian, isDataAdmin, isInternalUser } = useUserRoles();
    const { isFeatureEnabled } = useContext(FeatureFlagsContext);
    const isChartsEnabled = isFeatureEnabled('LibraryReportsBuilder');
    const canSeeActivities = isAdmin || isBuilder || isLibrarian;
    const canSeeDataTemplates = isDataAdmin || isAdmin;
    const canSeeDataTab = canSeeDataTemplates && (isInternalUser || isChartsEnabled);
    const navItems = useMemo(() => [
        {
            title: 'Activities',
            path: '/library/activities',
            icon: 'navProtocol',
            hidden: !canSeeActivities,
        },
        {
            title: 'Data templates',
            path: '/library/data-templates',
            icon: 'navData',
            hidden: !canSeeDataTemplates,
        },
        {
            title: 'Data',
            path: isInternalUser ? '/library/data-views' : '/library/charts',
            icon: 'navData',
            hidden: !canSeeDataTab,
            links: [
                {
                    title: 'Datasets',
                    path: '/library/data-views',
                    badgeProps: { label: 'Internal' },
                    hidden: !isInternalUser,
                },
                {
                    title: 'Charts',
                    path: '/library/charts',
                    hidden: !isChartsEnabled,
                },
                {
                    title: 'Dashboards',
                    path: '/library/dashboards',
                    hidden: !isChartsEnabled,
                },
            ],
        },
    ], [canSeeActivities, canSeeDataTab, isChartsEnabled, isInternalUser]);
    return (_jsx(ProvidersWrapper, { children: _jsxs("div", { className: 'flex grow overflow-hidden', children: [_jsx("div", { className: 'flex flex-col bg-neutral-75', "data-testid": 'side-nav-menu', children: _jsx(SideNav, { activeLinkPath: pathname, items: navItems, LinkComponent: Link, collapsable: true }) }), _jsx("div", { className: 'flex h-full w-full grow flex-col overflow-hidden bg-white', children: _jsx(Suspense, { fallback: _jsx("section", { className: 'flex items-center justify-center h-full', children: _jsx(Spinner, {}) }), children: _jsx(Outlet, {}) }) })] }) }));
};
